export type ConsentPreferences = {
  analytics: boolean;
  functional: boolean;
  marketing: boolean;
  hasResponded?: boolean;
  timestamp?: number;
};

const STORAGE_KEY = "properdiet_consent_preferences";
const DEFAULT_CONSENT: ConsentPreferences = {
  analytics: false,
  functional: true,
  marketing: false,
  hasResponded: false,
};

const listeners = new Set<(preferences: ConsentPreferences) => void>();

export function getAnalyticsConsent(): ConsentPreferences {
  if (typeof localStorage === "undefined") return DEFAULT_CONSENT;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return DEFAULT_CONSENT;
  try {
    return { ...DEFAULT_CONSENT, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_CONSENT;
  }
}

export function setAnalyticsConsent(preferences: ConsentPreferences) {
  if (typeof localStorage !== "undefined") {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
  }
  listeners.forEach((listener) => listener(preferences));
}

export function isAnalyticsAllowed(): boolean {
  return getAnalyticsConsent().analytics === true;
}

export function subscribeToConsentChanges(listener: (preferences: ConsentPreferences) => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
